module.exports = __webpack_public_path__ + "media/images/landing_page/stars-952c5fd4bb57c1d6af757566bbe49960.jpg";